export function LaunchKitSection() {
  return (
    <section id="launch-kit" className="possibilities shell">
      <div className="section-heading fade-up">
        <span className="kicker">THE COMPLETE LAUNCH KIT</span>
        <h2>
          More than a website builder.
          <br />
          <em>Much more.</em>
        </h2>
        <p>
          Landed turns one idea into every digital touchpoint you need to launch, grow, and look
          established from day one.
        </p>
      </div>
      <div className="feature-grid">
        <article className="feature main-card fade-up">
          <div className="tag">AI WEBSITES</div>
          <h3>Describe it. Land a website.</h3>
          <p>
            Go from a simple prompt to a polished, responsive site in seconds. Refine everything
            without touching code.
          </p>
          <div className="site-stack">
            <div className="site-back" />
            <div className="site-front">
              <span />
              <h4>
                Your big idea,
                <br />
                beautifully launched.
              </h4>
              <button type="button">Get started</button>
            </div>
          </div>
          <a href="/register">Explore AI websites &rarr;</a>
        </article>

        <article className="feature wait-card-feature fade-up" style={{transitionDelay: '0.08s'}}>
          <div className="tag">WAITLISTS + FORMS</div>
          <h3>Build momentum before launch.</h3>
          <p>
            Create waitlists, lead capture, surveys, and multi-step forms&mdash;with analytics,
            referrals, webhooks, and CSV export built in.
          </p>
          <div className="signup">
            <div className="counter">
              <b>2,418</b>
              <span>people are waiting</span>
            </div>
            <div className="growth">
              <span style={{height: '28%'}} />
              <span style={{height: '42%'}} />
              <span style={{height: '38%'}} />
              <span style={{height: '68%'}} />
              <span style={{height: '82%'}} />
              <span style={{height: '100%'}} />
            </div>
            <div className="joiners">
              <i>MJ</i>
              <i>AL</i>
              <i>KM</i>
              <i>+</i>
            </div>
          </div>
          <a href="/forms">Explore forms and waitlists &rarr;</a>
        </article>

        <article className="feature signature-feature fade-up" style={{transitionDelay: '0.16s'}}>
          <div className="tag">22 SIGNATURE TEMPLATES &middot; 17 INDUSTRIES</div>
          <h3>Make every message on-brand.</h3>
          <p>
            Preview, customize, and deploy professional HTML signatures compatible with Gmail,
            Outlook, and major email clients.
          </p>
          <div className="mini-signature">
            <i>NS</i>
            <div>
              <b>Noah Stone</b>
              <span>Creative Director</span>
              <small>noah@northstar.co</small>
            </div>
            <strong>
              north
              <br />
              star.
            </strong>
          </div>
          <a href="/signatures">Browse email signatures &rarr;</a>
        </article>

        <article className="feature errors-feature fade-up" style={{transitionDelay: '0.24s'}}>
          <div className="tag">404 + 500 PAGES</div>
          <h3>Even errors can feel intentional.</h3>
          <p>Turn dead ends into memorable, branded moments that guide visitors back.</p>
          <div className="error-tabs">
            <span>404</span> <span>500</span>
            <div className="error-tab-card">
              <b>Oops.</b>
              <small>This page took a wrong turn.</small>
              <button type="button">Go home</button>
            </div>
          </div>
          <a href="/register">Design an error page &rarr;</a>
        </article>
      </div>
    </section>
  );
}
